var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhatsapp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "whatsapp_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  mask: "url(#whatsapp_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.867 21.278c.285.108 1.814.887 2.125 1.048l.17.086c.217.108.364.182.426.29.078.134.078.778-.181 1.53-.26.752-1.502 1.439-2.1 1.531-.535.083-1.213.118-1.958-.127a17.452 17.452 0 0 1-1.773-.678c-2.916-1.304-4.887-4.229-5.26-4.782a3.714 3.714 0 0 0-.054-.08l-.002-.003c-.165-.227-1.268-1.75-1.268-3.326 0-1.483.704-2.26 1.028-2.618.022-.025.043-.047.06-.068.286-.322.623-.403.83-.403.208 0 .415.002.596.011.023.002.046.002.07.001.181 0 .407-.002.63.552l.342.857c.268.676.565 1.425.617 1.533.078.161.13.35.026.564l-.044.092a1.842 1.842 0 0 1-.267.445c-.052.063-.105.13-.159.198-.107.135-.214.27-.308.366-.155.16-.317.335-.136.657.181.323.806 1.377 1.73 2.23.994.918 1.858 1.306 2.296 1.502.085.039.155.07.206.096.31.162.492.134.673-.08.182-.215.778-.94.985-1.263.207-.322.415-.268.7-.16Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20.317 6.745c3.33.001 6.455 1.343 8.805 3.778 2.35 2.436 3.644 5.672 3.643 9.115-.003 7.104-5.588 12.884-12.448 12.884h-.005c-2.083-.001-4.13-.542-5.948-1.569l-6.599 1.792 1.766-6.676a13.208 13.208 0 0 1-1.662-6.441c.003-7.104 5.587-12.883 12.448-12.883Zm-.004 23.6h.004c5.703 0 10.344-4.803 10.346-10.708.001-2.861-1.074-5.552-3.027-7.576s-4.551-3.14-7.315-3.14c-5.706 0-10.348 4.803-10.35 10.707 0 2.024.546 3.994 1.582 5.7l.246.405-1.045 3.951 3.915-1.063.378.232a10.066 10.066 0 0 0 5.266 1.493Z",
  clipRule: "evenodd"
}))));
export default SvgWhatsapp;